import type { TradingRecommendationType } from '@/modelsLocal/trading-recommendation';
import type { UserFrontendFlags } from '@/models/user';
import type {FeatureConfigKey} from '@/models/feature-config';

interface IntroVideoConfig {
  bunnyEmbedUrl: string;
  flagKey: keyof UserFrontendFlags;
  featureKey: FeatureConfigKey;
  title: string;
}

export const INTRO_VIDEO_CONFIG: Record<TradingRecommendationType, IntroVideoConfig> = {
  CORE: {
    bunnyEmbedUrl: 'https://iframe.mediadelivery.net/embed/491441/46895ad0-b8cd-4c16-82be-72ba110c8f10',
    flagKey: 'introCore',
    featureKey: 'coreRecommendations',
    title: 'Einführung: Kernstrategie',
  },
  EARNINGS: {
    bunnyEmbedUrl: 'https://iframe.mediadelivery.net/embed/491441/f7486472-7459-46be-b286-eb8b8137a72b',
    flagKey: 'introEarnings',
    featureKey: 'earningRecommendations',
    title: 'Einführung: Earnings Trades',
  },
  SWING: {
    bunnyEmbedUrl: 'https://iframe.mediadelivery.net/embed/491441/e5386f0d-7b4e-4a04-8168-16fd17e87112',
    flagKey: 'introSwing',
    featureKey: 'swingTradeRecommendations',
    title: 'Einführung: Swing Trades',
  },
  LONGTERM: {
    bunnyEmbedUrl: 'https://iframe.mediadelivery.net/embed/491441/5a521505-c916-42f1-bfdc-c35a6f20d618',
    flagKey: 'introLong',
    featureKey: 'longTermRecommendations',
    title: 'Einführung: Langzeit Trades',
  },
};
